import { createSlice } from '@reduxjs/toolkit'

export const counterSlice = createSlice(
    {
        name: 'teacherIds',
        initialState: {

            isUnitData: [],
            isNoSubjectFound: '',
            isSelectedTopicIds: []

        },
        reducers: {

            UnitData: (state, action) => {
                console.log("isUnitData", action.payload);
                state.isUnitData = action.payload
            },
            NoSubjectFound: (state, action) => {
                console.log("NoSubjectFound", action.payload);
                state.isNoSubjectFound = action.payload
            },
            SelectedTopicIds: (state, action) => {
                console.log("SelectedTopicIds", action.payload);
                state.isSelectedTopicIds = action.payload
            },

        },
    },

)

// Action creators are generated for each case reducer function
export const { UnitData, NoSubjectFound, SelectedTopicIds } = counterSlice.actions

export default counterSlice.reducer